import { ORDER_FEE_RATE_POLLING_INTERVAL } from 'config'
import { useEffect } from 'react'
import { useAppDispatch } from 'store'
import { useAccountInfo, useUserId } from 'store/account/hooks'
import { useInterval } from 'usehooks-ts'
import { getSpotFeeRatesAction } from './actions/getSpotFeeRatesActions'
import { getSpotOpenOrdersAction } from './actions/getSpotOpenOrdersActions'
import { getMarketPriceConfigAction } from 'store/market/actions/getMarketPriceConfigActions'

function usePollingSpotFeeRate() {
  const dispatch = useAppDispatch()

  const userId = useUserId()
  useEffect(() => {
    if (!userId) return
    dispatch(getSpotFeeRatesAction())
  }, [userId])
  useInterval(
    () => {
      dispatch(getSpotFeeRatesAction())
    },
    userId ? ORDER_FEE_RATE_POLLING_INTERVAL : null,
  )
}

function useFetchSpotOpenOrders() {
  const dispatch = useAppDispatch()
  const { userId = 0, accountId = 0 } = useAccountInfo()
  useEffect(() => {
    if (!userId) return
    dispatch(getSpotOpenOrdersAction(accountId))
  }, [userId])
}

export function useFetchMarketPriceConfig() {
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(getMarketPriceConfigAction())
  }, [])
}

export default function Updater() {
  usePollingSpotFeeRate()
  useFetchSpotOpenOrders()
  useFetchMarketPriceConfig()

  return null
}
